import React from 'react';
import {Checkbox} from 'antd';
import 'moment/min/locales';

import {GIFT_STATUS_FREE} from 'constants/statuses';
import {SearchParams} from '../../types';
import {useSelector} from 'react-redux';
import {getAppSettings} from 'app/reducers/commonData/selectors';

type OwnProps = {
    searchParams: SearchParams;
    onClearParams(params: any): void;
    onSearchFreeGifts(status?: string): void;
    onSearchByMonth(params: any): void;
};

const SearchForGuest: React.FC<OwnProps> = ({searchParams, onSearchFreeGifts}) => {
    const handleChangeFreeStatus = (event: any): void => {
        if (event.target.checked) {
            onSearchFreeGifts(GIFT_STATUS_FREE);
        } else {
            onSearchFreeGifts();
        }
    };
    const appSettings = useSelector(getAppSettings);

    return (
        <>
            <p style={{fontSize: '20px', margin: 0}}>
                <strong>{appSettings?.giftsCount}</strong> дітей чекають на свої подарунки. Обери бажання та допоможи
                здійснити його до Дня Святого Миколая.
            </p>
            <div className="filter">
                <div className="filter__item">
                    <Checkbox
                        id="freeStatusCheckbox"
                        checked={searchParams.status === GIFT_STATUS_FREE}
                        onChange={handleChangeFreeStatus}
                    >
                        Показати лише вільні мрії
                    </Checkbox>
                </div>
            </div>
        </>
    );
};

export default SearchForGuest;
